/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * SlideArrow left
 *
 * @file SlideArrowLeft.jsx
 * @author ujjwal Sana
 * @since 1.2.8
 */

import React from 'react';
import { IconButton, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Icon from '../icons/Icon';
import SlideArrowStyles from './styles/SlideArrowStyles';
import { SPACEKEY, ENTERKEY } from '../../common/constants';

const SlideArrowLeft = ({
  classes, onClick, onEnterEvent, disabled
}) => {
  /**
   * Function to handle left slider nav trigger button keydown events
   * @param {*} event
   */
  const handleKeyDown = (event) => {
    switch (event.code) {
      case SPACEKEY:
      case ENTERKEY:
        onEnterEvent();
        break;
      default:
        break;
    }
    event.stopPropagation();
  };

  return (
    <IconButton
      onClick={onClick}
      onKeyDown={handleKeyDown}
      classes={{ root: classes.navButtonV1 }}
      className={`${classes.contentNavV1} ${classes.leftNavV1} slider-arrow-left`}
      aria-disabled={onClick === null}
      type="button"
      disabled={disabled}
      data-type="navLeft"
      aria-live="announcement"
      tabIndex={onClick === null ? '-1' : '0'}
    >
      <Icon name="ChevronIcon" />
    </IconButton>);
};

SlideArrowLeft.defaultProps = {
  onClick: null,
  onEnterEvent: () => {},
  disabled: false
};

SlideArrowLeft.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onEnterEvent: PropTypes.func,
  disabled: PropTypes.bool
};

export default withStyles(SlideArrowStyles, { name: 'slideArrowLeft' })(injectIntl(SlideArrowLeft));
